import * as gallery from "./gallery";
import * as modal from "./modal";

export namespace Overlay {
  export const Gallery = gallery.default;
  export type GalleryHandler = gallery.GalleryHandler;
  export const Modal = modal.default;
  export const ModalTrigger = modal.ModalTrigger;
  export const ModalContent = modal.ModalContent;
  export const ModalFooter = modal.ModalFooter;
}
